export default "__VITE_ASSET__BLsYU1jl__"